import React from 'react';
import { Helmet } from 'react-helmet';

const MetaTags = () => (
  <Helmet>
    {/* Primary Meta Tags */}
    <title>beatstake - fans become stakeholders in music they love.</title>
    <meta name="title" content="beatstake - fans become stakeholders in music they love." />
    <meta 
      name="description" 
      content="At beatstake, we empower fans to become stakeholders in the music they love—turning passion into ownership and ownership into income. Join us in pioneering a new era of collaborative music appreciation." 
    />
    <meta 
      name="keywords" 
      content="music, fans, shareholders, stakeholders, music ownership, streaming revenue, collaborative music, beatstake" 
    />
    <meta name="robots" content="index, follow" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="canonical" href="https://beatstake.com" />
    <link rel="image_src" href="https://beatstake-public-bucket.s3.us-east-1.amazonaws.com/1.png" />

    {/* Open Graph / Facebook Meta Tags */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://beatstake.com" />
    <meta property="og:title" content="beatstake - fans become stakeholders in music they love." />
    <meta 
      property="og:description" 
      content="At beatstake, fans transform their passion into ownership and income by becoming stakeholders in the music they love. Experience the future of music collaboration." 
    />
    <meta 
      property="og:image" 
      content="https://beatstake-public-bucket.s3.us-east-1.amazonaws.com/1.png" 
    />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:image:alt" content="beatstake logo – fans become stakeholders in music they love" />
    <meta property="og:site_name" content="beatstake" />

    {/* Twitter Meta Tags */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:url" content="https://beatstake.com" />
    <meta name="twitter:title" content="beatstake - fans become stakeholders in music they love." />
    <meta 
      name="twitter:description" 
      content="Join beatstake and become a stakeholder in the music you love. Turn your passion into ownership and income, and share in the success of your favorite songs!" 
    />
    <meta 
      name="twitter:image" 
      content="https://beatstake-public-bucket.s3.us-east-1.amazonaws.com/1.png" 
    />
    <meta name="twitter:image:alt" content="beatstake logo – fans become stakeholders in music they love" />
    <meta name="twitter:site" content="@beatstake" />
    <meta name="twitter:creator" content="@beatstake" />

    {/* Additional Tags */}
    <meta name="theme-color" content="#317EFB" />

    {/* Social Media Profile Links */}
    <link rel="me" href="https://www.tiktok.com/@beatstake" />
    <link rel="me" href="https://www.instagram.com/beatstake_official" />
    <link rel="me" href="https://bsky.app/profile/beatstakeofficial.bsky.social" />
    <link rel="me" href="https://www.facebook.com/beatstakeofficial" />
  </Helmet>
);

export default MetaTags;